import { createIcon } from '@chakra-ui/react';

export const TrashIcon = createIcon({
  displayName: 'TrashIcon',
  viewBox: '0 0 32 32',
  path: [
    <path
      key="1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 4H12.6667L11.3333 5.33333H6.66667V8H25.3333V5.33333H20.6667L19.3333 4ZM21.3333 12V25.3333H10.6667V12H21.3333ZM8.00001 9.33333H24V25.3333C24 26.8 22.8 28 21.3333 28H10.6667C9.20001 28 8.00001 26.8 8.00001 25.3333V9.33333Z"
      fill="#AA2C23"
    />,
    <rect
      key="2"
      x="12"
      y="13.3333"
      width="2.66667"
      height="10.6667"
      fill="#AA2C23"
    />,
    <rect
      key="3"
      x="17.3333"
      y="13.3333"
      width="2.66667"
      height="10.6667"
      fill="#AA2C23"
    />
  ]
});
